import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
    import type { PropType } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SunObject',
  props: {
        position: {
            required: true,
            type: Object as PropType<{x:number, y:number, z:number}>,
        },
        transparent: {
            required: false,
            type: Boolean as PropType<boolean>,
            default: false,
        }
    },
  setup(__props) {

    const props = __props

    // have to copy this for some reason idk make it an array for good measure
    const positionCopy = computed<[number, number, number]>(() => [props.position.x, props.position.y, props.position.z])
    


return (_ctx: any,_cache: any) => {
  const _component_TresSphereGeometry = _resolveComponent("TresSphereGeometry")!
  const _component_TresMeshBasicMaterial = _resolveComponent("TresMeshBasicMaterial")!
  const _component_TresMesh = _resolveComponent("TresMesh")!
  const _component_TresObject3D = _resolveComponent("TresObject3D")!

  return (_openBlock(), _createBlock(_component_TresObject3D, { position: positionCopy.value }, {
    default: _withCtx(() => [
      _createVNode(_component_TresMesh, null, {
        default: _withCtx(() => [
          _createVNode(_component_TresSphereGeometry, { args: [0.5, 20, 16,] }),
          (props.transparent)
            ? (_openBlock(), _createBlock(_component_TresMeshBasicMaterial, {
                key: 0,
                color: "#ffffff",
                transparent: true,
                opacity: 0.3
              }))
            : (_openBlock(), _createBlock(_component_TresMeshBasicMaterial, {
                key: 1,
                color: "#ffffff"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["position"]))
}
}

})